import { render, staticRenderFns } from "./Signaturepad.vue?vue&type=template&id=17618206&scoped=true&"
import script from "./Signaturepad.vue?vue&type=script&lang=js&"
export * from "./Signaturepad.vue?vue&type=script&lang=js&"
import style0 from "./Signaturepad.vue?vue&type=style&index=0&id=17618206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17618206",
  null
  
)

export default component.exports